export var TypographyLevel;
(function (TypographyLevel) {
    TypographyLevel["BodyXs"] = "body-xs";
    TypographyLevel["BodySm"] = "body-sm";
    TypographyLevel["BodyMd"] = "body-md";
    TypographyLevel["BodyLg"] = "body-lg";
    TypographyLevel["Paragraph"] = "paragraph";
})(TypographyLevel || (TypographyLevel = {}));
